import { ENV_PREPROD, ENV_PROD } from 'constants/environment';
import { TicketActionType } from 'data/__generated__';
import { getExtendedFormattedDatetime } from 'helpers/dateTimes';

export const PRIORITY_LABELS: Record<string, string> = {
    '0': 'Faible',
    '1': 'Normale',
    '2': 'Haute',
    '3': 'Urgente',
};

export const CRITICALITY_LABELS: Record<string, string> = {
    normal: 'Normale',
    high: 'Haute',
    block: 'Bloquante',
};

export const TICKET_ACTION_TYPE_LABELS: Record<TicketActionType, string> = {
    [TicketActionType.AssignToUser]: 'Prise en charge',
    [TicketActionType.AddPhoto]: 'Photo',
    [TicketActionType.AddNote]: 'Note',
    [TicketActionType.ReassignToManager]: 'Réaffecté au manager',
    [TicketActionType.RequestValidation]: 'Demande de validation',
};

export function formatTicketDatetime(value: number | null | undefined): string {
    if (value == null) {
        return '—';
    }

    return getExtendedFormattedDatetime(value);
}

export function formatOdooRef(ref: { id: number; name: string } | null | undefined): string {
    if (!ref) {
        return '—';
    }

    return `${ref.name} (#${ref.id})`;
}

export function displayValue(value: string | number | boolean | null | undefined): string {
    if (value === true) {
        return 'Oui';
    }
    if (value === false) {
        return 'Non';
    }
    if (value == null || value === '') {
        return '—';
    }

    return String(value);
}

export function htmlToText(html: string | null | undefined): string {
    if (!html) {
        return '';
    }

    let text = html.replace(/<br\s*\/?>/gi, '\n');
    text = text.replace(/<\/(div|p|li|h[1-6])>/gi, '\n');
    text = text.replace(/<li[^>]*>/gi, '\n• ');
    text = text.replace(/<[^>]+>/g, '');
    text = text.replace(/&nbsp;/g, ' ');
    text = text.replace(/&amp;/g, '&');
    text = text.replace(/&lt;/g, '<');
    text = text.replace(/&gt;/g, '>');
    text = text.replace(/&quot;/g, '"');
    text = text.replace(/&#39;/g, "'");
    text = text.replace(/&apos;/g, "'");
    text = text.replace(/\n{3,}/g, '\n\n');

    return text
        .split('\n')
        .map((line) => line.trim())
        .join('\n')
        .trim();
}

export function getOdooTicketUrl(odooId: number): string {
    const odooBaseUrl =
        window.__TOTENV__.ENV === ENV_PROD
            ? 'https://odoo.neocorner.fr'
            : window.__TOTENV__.ENV === ENV_PREPROD
              ? 'https://odoo-preprod.totem.co'
              : 'https://odoo-inte.totem.co';

    return `${odooBaseUrl}/web#id=${odooId}&model=helpdesk.ticket&view_type=form`;
}
